import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { contextualSlice } from 'redux/slices/contextualSlice';

export const plannerServiceApi = createApi({
  reducerPath: 'plannerServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    plan: builder.mutation<any, any>({
      query: ({
        origin,
        destination,
        time,
        date,
        wheelchair,
        arriveBy,
        deviceType,
        intermediateStops,
        toPlaceTypeId,
        toPlaceValue,
        fromPlaceTypeId,
        fromPlaceValue,
        operatorsFilters,
        maxLegDuration,
        intermediatePlacesId,
        times,
      }) => {
        let modes = 'WALK';
        if (operatorsFilters.length) {
          if (operatorsFilters.indexOf('Cercanías') >= 0) modes = modes + ',RAIL';
          if (operatorsFilters.indexOf('EMT Palma') >= 0) modes = modes + ',BUS';
          if (operatorsFilters.indexOf('Metro') >= 0) modes = modes + ',SUBWAY';
          if (operatorsFilters.indexOf('Metro ligero') >= 0) modes = modes + ',TRAM';
        } else {
          modes = modes + ',TRANSIT';
        }
        const fromPlaceVal = fromPlaceValue?.replaceAll(' ', '_');
        return {
          url: `/plan/?from=${origin}&to=${destination}&time=${time}&wheelchair=${
            wheelchair ?? false
          }&mode=${modes}&date=${date}&arriveBy=${arriveBy}&deviceType=${deviceType}&toPlaceTypeId=${toPlaceTypeId}&toPlaceValue=${toPlaceValue}&fromPlaceId=${fromPlaceTypeId}&fromPlaceValue=${fromPlaceVal}
          ${maxLegDuration ? `&maxLegDuration=${maxLegDuration}` : ''}${
            intermediateStops ?? ''
          }${intermediatePlacesId ?? ''}${times ?? ''}`,
          method: 'GET',
        };
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          dispatch(contextualSlice.actions.updateShowLoading(true));
          await queryFulfilled;
          dispatch(contextualSlice.actions.updateShowLoading(false));
          //dispatch(contextualSlice.actions.updateContextualMessage({message:'Éxito', type:"success"}))
        } catch (err: any) {
          dispatch(contextualSlice.actions.updateShowLoading(false));
          dispatch(
            contextualSlice.actions.updateContextualMessage({
              message: err['error']['error'],
              type: 'error',
            }),
          );
        }
      },
    }),
    obtainPlanById: builder.mutation<any, any>({
      query: ({ id }) => {
        return {
          url: `/plan/share?planId=${id}`,
          method: 'GET',
        };
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {}
      },
    }),
  }),
});

export const { usePlanMutation, useObtainPlanByIdMutation } = plannerServiceApi;
